import { useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import { Button, FormGroup, Input, Modal, ModalBody, ModalHeader, Table } from "reactstrap";

import componenteService from "services/ComponenteService";
import { StatusComponenteEnum, estadoComponenteText, statusComponenteText } from "services/ComponenteService";

export default function ModalIncluir({ isOpen, idContrato, onClose, onSelect }) {
  const [termo, setTermo] = useState('')
  const [items, setItems] = useState([])
  const termoRef = useRef()

  const handleOpened = () => {
    termoRef.current?.focus()
  }

  useEffect(() => {
    if (!isOpen) {
      setTermo('')
      setItems([])
    }
  }, [isOpen])

  const handleSubmit = (e) => {
    e.preventDefault()

    if (!termo) {
      toast.error("Preencha o QR Code")
      return
    }

    componenteService.get(idContrato, null, null, termo, StatusComponenteEnum.ESTOQUE, null, false).then(res => {
      if (res.success) {
        setItems(res.data)
      }
    })
  }

  return (
    <Modal isOpen={isOpen} toggle={onClose} size="lg" onOpened={handleOpened}>
      <ModalHeader toggle={onClose}>Buscar Componente</ModalHeader>
      <ModalBody>
        <form onSubmit={handleSubmit} className="row">
          <FormGroup className="col-12">
            <label htmlFor="termo">QR Code</label>
            <Input id="termo" innerRef={termoRef} type="text" value={termo} onChange={e => setTermo(e.target.value)} />
          </FormGroup>
          <div className="col-12 text-right">
            <Button type="submit" color="primary">Buscar</Button>
            <Button type="button" color="primary" outline onClick={onClose}>Fechar</Button>
          </div>
        </form>
        <Table className="align-items-center table-flush mt-4" responsive>
          <thead className="thead-light">
            <tr>
              <th scope="col">QRCode</th>
              <th scope="col">Tipo</th>
              <th scope="col">Modelo</th>
              <th scope="col">Estado</th>
              <th scope="col">Status</th>
              <th scope="col" style={{ width: 60 }}></th>
            </tr>
          </thead>
          <tbody>
            {items.map(item => (
              <tr key={item.id}>
                <td>{item.qrCode}</td>
                <td>{item.tipoComponente}</td>
                <td>{item.modelo}</td>
                <td>{estadoComponenteText(item.estado)}</td>
                <td>{statusComponenteText(item.status)}</td>
                <td>
                  <Button
                    color="primary"
                    size="sm"
                    onClick={() => onSelect && onSelect(item)}
                    disabled={item.status != StatusComponenteEnum.ESTOQUE}
                  >
                    Incluir
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </ModalBody>
    </Modal>
  )
}
